import { txRegistryApi } from '@/apis';

export default {
  async initEregTxRegistry({ commit, dispatch }) {
    commit('reset');
    commit('setLoading', true);
    const requests = [dispatch('fetchList'), dispatch('fetchSummary')];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  async incrementTxs({ commit, dispatch }) {
    commit('setAdding', true);
    await dispatch('fetchList');
    commit('setAdding', false);
  },
  async fetchList({ commit }) {
    try {
      const response = await txRegistryApi.requestList();
      commit('addTxs', response.data.txs);
      commit('setPaging', response.data.paging);
    } catch (error) {
      commit('setError', error);
    }
  },
  async fetchSummary({ commit }) {
    try {
      const response = await txRegistryApi.requestSummary();
      commit('setSummary', response.data);
    } catch (error) {
      commit('setError', error);
    }
  },
};
